
import { useEffect } from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import { useMapboxToken } from './useMapboxToken';
import { useGeolocationService } from './useGeolocationService';

export const useMapbox = () => {
  const { 
    mapboxToken, 
    isLoading, 
    error, 
    clearToken,
    refreshToken 
  } = useMapboxToken();
  
  const {
    userLocation,
    isGettingLocation,
    getUserLocation,
    error: locationError,
    setError
  } = useGeolocationService();
  
  const isMobile = useIsMobile();
  
  useEffect(() => {
    // If on mobile, try to get user location automatically
    if (isMobile) {
      getUserLocation().catch(err => console.error('Could not get initial location:', err));
    }
  }, [isMobile, getUserLocation]);
  
  return { 
    mapboxToken, 
    isLoading, 
    error: error || locationError, 
    clearToken,
    refreshToken, // Export refreshToken from useMapbox
    userLocation, 
    getUserLocation, 
    isGettingLocation 
  };
};
